// The web arm offers the desktop app; it never reaches for the daemon
// (sdk ADR-017). Open is the desktop-status pill; this slot is Download.
import type { ReactNode } from 'react';
import { DownloadForMac } from '../components/DownloadForMac';

export interface DesktopHandoffOfferProps {
  /** Story harness override; production composes `DownloadForMac`. */
  readonly download?: ReactNode;
}

export function DesktopHandoffOffer({ download }: DesktopHandoffOfferProps) {
  return (
    <aside
      data-testid="desktop-handoff-offer"
      aria-label="Download App"
    >
      {/* Download is visible from first paint. A browser cannot observe
          whether the scheme on the status pill opened anything. */}
      <div data-testid="desktop-handoff-fallback">
        {download ?? <DownloadForMac compact />}
      </div>
    </aside>
  );
}
